import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundaryGlobal } from "./components/ErrorBoundary.tsx";
import "./index.css";
import { checkBuildVersion } from "./lib/buildVersion";
import { logRoadmapReport } from "./lib/roadmap";

// Check for stale build and auto-reload if needed
checkBuildVersion();

// DEV-only: log roadmap & optimization report
logRoadmapReport();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundaryGlobal>
    <App />
  </ErrorBoundaryGlobal>
);
